import React from 'react';
import { Music2, Clock, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';

const SuggestionCard = ({ suggestion }) => {
  const getStatusConfig = (status) => {
    switch (status) {
      case 'accepted':
        return {
          icon: CheckCircle,
          label: 'Acceptée',
          color: 'text-green-500',
          bgColor: 'bg-green-500/10',
          borderColor: 'border-green-500/30'
        };
      case 'rejected':
        return {
          icon: XCircle,
          label: 'Rejetée',
          color: 'text-red-500',
          bgColor: 'bg-red-500/10',
          borderColor: 'border-red-500/30'
        };
      case 'played':
        return {
          icon: CheckCircle,
          label: 'Jouée',
          color: 'text-blue-500',
          bgColor: 'bg-blue-500/10',
          borderColor: 'border-blue-500/30'
        };
      default:
        return {
          icon: AlertCircle,
          label: 'En attente',
          color: 'text-orange-500',
          bgColor: 'bg-orange-500/10',
          borderColor: 'border-orange-500/30'
        };
    }
  };

  const statusConfig = getStatusConfig(suggestion.status);
  const StatusIcon = statusConfig.icon;

  const getTimeAgo = () => {
    try {
      return formatDistanceToNow(new Date(suggestion.created_at), {
        addSuffix: true,
        locale: fr
      });
    } catch (e) {
      return 'Récemment';
    }
  };

  return (
    <div 
      className={`bg-slate-900/50 rounded-xl border ${statusConfig.borderColor} p-4 transition-all hover:bg-slate-900/70`}
    >
      <div className="flex items-start gap-3">
        <div className={`p-2 ${statusConfig.bgColor} rounded-lg flex-shrink-0`}>
          <Music2 className={`w-5 h-5 ${statusConfig.color}`} />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-white truncate">{suggestion.requested_title}</h4>
          {suggestion.requested_artist && (
            <p className="text-sm text-slate-400 truncate">{suggestion.requested_artist}</p>
          )}
          {suggestion.link && (
            <a 
              href={suggestion.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-xs text-orange-500 hover:text-orange-400 truncate block mt-1"
            >
              🔗 Lien Spotify
            </a>
          )}
          
          <div className="flex items-center gap-3 mt-2">
            <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 ${statusConfig.bgColor} ${statusConfig.color} text-xs font-medium rounded-full`}>
              <StatusIcon className="w-3.5 h-3.5" />
              {statusConfig.label}
            </span>
            <span className="flex items-center gap-1 text-xs text-slate-500">
              <Clock className="w-3.5 h-3.5" />
              {getTimeAgo()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuggestionCard;
